/**
* In this file contains the forgot password screen UI designs and forms functionality
**/
import { useState,useEffect } from 'react';
import {Link ,useNavigate} from 'react-router-dom';
import Otpmodal from './../../shared/modals/Otpmodal';
import {validate} from './../../services/ValidationService';
import * as Yup from 'yup';
import ApiService from './../../services/ApiService';
import { toast } from 'react-toastify';
import constantVariables from './../../dataset/constantVariables.json';

function ForgotPassword() {
	//Intial state declaraction
	 const [modal, setModal] = useState({});
	 const [values, setValues ]= useState({username:'',password:''});
	 const [error, setError ]= useState({});
	 const navigate=useNavigate();
	 
	 //To handle OTP modal popup close
	 const handleClose = () => setModal({});
	 
	 //Reset the sessionStorage
	useEffect(()=>{
		return()=>{
		  sessionStorage.removeItem('role');
		}
	},[])
	 
	 //validate patterns
	 const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	 const mobilePattern =  /^[\d()+ -]{10,}$/;
	 
	 /**
	 * Validation schema for forgot Password form
	 * @username pass valid email id or mobile number
	 **/
        var forgotPasswordfields=[{ name: 'username', validation: Yup.string().test('is-email-or-mobile', constantVariables.error.validUserName, (value) => { return emailPattern.test(value) || mobilePattern.test(value); }).required(constantVariables.error.userName)}];
   
   
   /**
   * To handle input change function
   * @e we capture the input fields events
   **/
   const handleChange=async (e)=>{
		e.preventDefault();
		const {name,value}=e.target;  
		 setValues({...values,[name]:value});
		 const Errors = await validate({ [name]: value }, forgotPasswordfields);
			setError({...error,[name]:Errors[name]});
   }
   
   /**
   * To handle login submit function
   * @e we capture the forgot Password form events
   **/
   const handleSubmit=async (e)=>{
	   e.preventDefault();
	   	  const Errors = await validate(values, forgotPasswordfields);
			setError(Errors);
			if(!Object.keys(Errors).length){
			var data={};
			var role=sessionStorage.getItem('role');
			data.username=values.username;
			data.verified=false;
			// Set isAdmin flag based on the role
			data.isAdmin = parseInt(role) === 3 ? true : parseInt(role) === 4 ? true : true; // false for hospital admin
			await ApiService.forgotPassword(data).then(async (response)=>{
				if(response.status===200){
					if(response?.data?.otp===true){
						setModal({
							id:response.data.user,
							show:true,
							source:'reset'
						})
					}
				}else{
					toast.error(response?.data?.message);
				}
				
			});
		}
   }
	
	/** This function is used to go back to login screen **/
	const backToLogin = () => {
		var role = sessionStorage.getItem('role');
		// Navigate based on the user's role
		if (parseInt(role) === 2) {
		  navigate('/login/physician');
		} else if (parseInt(role) === 4) {
		  navigate('/login/hospital/admin'); // For hospital admin role
		} else {
		  navigate('/login/admin'); // Default case for admin login
		}
	  };
	  
   
  return (
    <main className="login-sec">
    <div className="container">
	{/*Import Otpmodal*/}
	 {Object.keys(modal).length !==0 && <Otpmodal 
	handleClose={handleClose} 
	userData={modal}
	 />}
     <section className="register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div className="container">
		{/** Logo **/}
          <div className="row justify-content-center">
            <div className="col-lg-12">
				<div className="d-flex justify-content-center pb-5">
					<Link to='/'  className="login-logo d-flex align-items-center">
						<img src="/assets/img/nurture-logo.svg" alt="lo" />
					</Link>
				</div>
				
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-10">
				<div className="wrap d-md-flex">
					<img src="/assets/img/physician-login-img.jpg" alt="lo" />
				
				<div id="loginForm">
					<h1>{constantVariables.auth.forgotPassword}</h1><br/>
					<h5>{constantVariables.auth.forgotTitle}</h5>
					
					{/*Forgot Password Form*/}	
					<form onSubmit={handleSubmit} autoComplete="off">
					  <div className="form-group">
							<label className="mb-1">{constantVariables.auth.userName}</label>
							<input type="text" value={values.username?values.username:''} name="username" onChange={handleChange} className="form-control" placeholder={constantVariables.auth.userName} />
							<i className="iconly-Light-User"></i>
							{error && error.username && <span className="text-danger">{error.username}</span>}
						  </div>
					  <div className="mb-4">
						<button type="submit" className="btn btn-tmBlue w-100">
							Reset Password</button>
					  </div>
					</form>
					{/*End Forgot Password Form*/}	
					
					<div className="footer-text">
						<p><span onClick={backToLogin} className="login_link">{constantVariables.auth.backToLogin}</span></p>
					</div>
				</div>
            </div>
          </div>
        </div>
        </div>
      </section>

    </div>
  </main>
  );
}

export default ForgotPassword;
